import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JobSearchFormComponent } from './job-search-form.component';
import { FormGroupModule } from '../form-group/form-group.module';
import { ReactiveFormsModule } from '@angular/forms';
import { JobSearchFilterTagComponent } from './job-search-filter-tag/job-search-filter-tag.component';
import { JobSearchSortComponent } from './job-search-sort/job-search-sort.component';

@NgModule({
  declarations: [
    JobSearchFormComponent,
    JobSearchFilterTagComponent,
    JobSearchSortComponent
  ],
  imports: [
    FormGroupModule,
    ReactiveFormsModule,
    CommonModule
  ],
  exports: [
    JobSearchFormComponent,
    JobSearchFilterTagComponent,
    JobSearchSortComponent
  ]
})
export class JobSearchFormModule { }
